import {CartesianPoint} from 'ui-library/charting/Types';

export default function getCartesianErrorRange<DataPoint extends CartesianPoint>(
  dataPoint: Pick<DataPoint, 'y' | 'errorValue'>
): [number, number] | null {
  return dataPoint.y == null || dataPoint.errorValue == null
    ? null
    : [
        (dataPoint.y as number) - (dataPoint.errorValue as number),
        (dataPoint.y as number) + (dataPoint.errorValue as number),
      ];
}

/**
 * Return the maximum and minimum error range extents.
 *
 * The range extents will be the smallest and largest values that need to be plotted, including error ranges.
 * To ensure these are the smallest and largest values to plot, points with null error values will also be
 * considered.
 */
export function getCartesianErrorRangeExtents<DataPoint extends CartesianPoint>(
  points: Array<Pick<DataPoint, 'y' | 'errorValue'>>
): [number, number] {
  const extents = points.flatMap((point) => getCartesianErrorRange(point) ?? [point.y as number]);
  return [Math.min(...extents), Math.max(...extents)];
}
